import { getEnumValuesFromPipelineSchema } from '@flows/configs/shared/schemaUtils'
import { BaseSchema_UnifiedLegalComfort3BasicRolandDe as schema } from '@flows/insurance/schemas'
import { getClaimsOptions } from '@flows/insurance/utils/stepContentUtils'

export const LEGAL_EXTENSIONS = {
  tenantProductKey: 'legal_comfort_3_tenant_roland_de',
  criminalProductKey: 'legal_comfort_3_criminal_roland_de',
}

const claimsOptionsFromSchema = getEnumValuesFromPipelineSchema(
  schema.shape.number_of_claims_in_last_5y.unwrap()
)

export const LEGAL_CONSTANTS = {
  claimsOptions: getClaimsOptions(claimsOptionsFromSchema.length),
}
